export const en = {
  bookDemoPage: {
    meta: { title: 'Book a Demo' },
    eyebrow: 'Book a demo',
    heading_main: 'See Purposely run ',
    heading_em: 'your volunteer program',
    lead: "A 30-minute walkthrough with our team. We'll run you through the admin-saving workflows, show you events in action, and answer anything about pricing and rollout.",
    expect: [
      {
        title: '30 minutes, quick chat',
        sub: 'We learn about your needs and tailor the call to that.',
      },
      {
        title: 'A roadmap, not a pitch',
        sub: "You'll leave with clear next steps, not a sales deck to ignore.",
      },
      {
        title: 'Pricing that scales with you',
        sub: 'Transparent pricing. No surprise add-ons.',
      },
    ],
    trust: {
      heading: 'Trusted by teams at',
      logos: ['Clio', 'Hootsuite', 'Boston Dynamics', 'GreenShield'],
    },
    cal: {
      heading: 'Pick a time that works',
      sub: "All times in your local timezone. We'll send a calendar invite immediately.",
    },
    fallback: {
      strong: 'Prefer email?',
      text: "We'll get you a time within one business day.",
      email: 'demo@purposely.co',
    },
  },
}
